import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

const baseUrl = 'https://coinranking1.p.rapidapi.com';
const headers =  {
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': '11911df31fmsh747dacfa019249ep1fb82ejsn6e9907ff9a84'
  }

export const cryptoApi = createApi({
    reducerPath: "cryptoAPI",
    baseQuery: fetchBaseQuery({baseUrl}),
    endpoints: (builder) => ({
        getCryptos: builder.query({
            query: () => ({url: `/coins?tiers=${1}`, headers: headers})
        }),
        getCryptoDetail: builder.query({
            query: (coinID) => ({url: `/coin/${coinID}`, headers: headers})
        }),
        getCryptoHistory: builder.query({
            query: ({coinID, timePeriod}) => ({url: `/coin/${coinID}/history/${timePeriod}`, headers: headers})
        }),
        getExchanges: builder.query({
            query: () => ({url: `/exchanges`, headers: headers})
        })
    })
})

export const {useGetCryptosQuery, useGetCryptoDetailQuery, useGetCryptoHistoryQuery, useGetExchangesQuery} = cryptoApi